export default __webpack_public_path__ + "static/media/logo-ADS.592931a6.png";